import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogFooter,
  DialogDescription,
} from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';
import { useDeleteDashboard } from '../../hooks/useDashboardData';
import type { Dashboard } from '../../types/analytics.types';

interface DeleteDashboardDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  dashboard: Dashboard | null;
  onSuccess?: () => void;
}

export function DeleteDashboardDialog({
  open,
  onOpenChange,
  dashboard,
  onSuccess,
}: DeleteDashboardDialogProps) {
  const deleteDashboard = useDeleteDashboard();

  const handleDelete = async () => {
    if (!dashboard) return;

    try {
      await deleteDashboard.mutateAsync(dashboard.id);
      onOpenChange(false);
      onSuccess?.();
    } catch (error) {
      console.error('Failed to delete dashboard:', error);
    }
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>Delete Dashboard</DialogTitle>
          <DialogDescription>
            Are you sure you want to delete "{dashboard?.name}"? This will remove
            all cards from the dashboard. This action cannot be undone.
          </DialogDescription>
        </DialogHeader>
        <DialogFooter>
          <Button variant="outline" onClick={() => onOpenChange(false)}>
            Cancel
          </Button>
          <Button
            variant="destructive"
            onClick={handleDelete}
            disabled={deleteDashboard.isPending}
          >
            {deleteDashboard.isPending ? 'Deleting...' : 'Delete'}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
